import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {
  notification
} from 'ant-design-vue'
import {
  VueAxios
} from './axios'
// import { ACCESS_TOKEN } from '@/store/mutation-types'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 20000, // 请求超时时间
})

// 不要将错误信息哑处理，应该将错误以合适的方式反馈到UI
const err = (error) => {
  if (error.response) {
    const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    // console.log(token)
    if (error.response.status === 403) {
      notification.error({
        message: '无权访问',
        description: data.message,
      })
    }
    if (error.response.status === 401) {
      notification.error({
        message: '无权访问',
        description: data.respMsg
      })
      // if (token) {
      //   // token过期情况
      //   store.dispatch('Logout').then(() => {
      //     console.log('logout Success')
      //     window.location.reload()
      //   })
      // }
    }
    if (error.response.status === 400) {
      notification.error({
        message: '请求出错',
        description: data.respMsg,
      })
    }
    if (error.response.status === 500) {
      notification.error({
        message: '后台错误',
        description: data.respMsg,
      })
      if (data.respMsg === '因修改了账号,请重新登录!') {
        store.dispatch('Logout').then(() => {
          window.location.reload()
        })
      }
    }
  } else {
    notification.error({
      message: '请重试',
      description: error.message,
    })
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use((config) => {
  // const token = Vue.ls.get(ACCESS_TOKEN)
  // if (token) {
  //   config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  // }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  },
}

export {
  installer as VueAxios, service as axios
}